import {createGAEvent, HTO, pushDataLayer} from '@optimaxdev/analytics/mobile';

import {call, select} from 'redux-saga/effects';
import {getAllQuote} from 'selectors/product/quoteProduct';
import {isHomeTryOnCart} from 'selectors/homeTryOn/homeTryOn';

/**
 * Send HTO non-interaction analytics for Thank page
 */
export function* sendThankPageAnalytics() {
    const {count, totals} = yield select(getAllQuote);
    const isHTOEnabled = yield select(isHomeTryOnCart);

    if (!isHTOEnabled) return;

    yield call(
        pushDataLayer,
        createGAEvent(
            HTO.TYP_ORDER,
            {
                itemsCount: count,
                orderSum: totals.total,
            },
            false,
        ),
    );
}
